import { render, staticRenderFns } from "./ContactEdition.vue?vue&type=template&id=29835fb8&"
import script from "./ContactEdition.vue?vue&type=script&lang=js&"
export * from "./ContactEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports